/**
 * Created by Jie Gao on 2018-11-02.
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {StarStruckGameConfig} from "../StarStruckGameConfig";
import {StarStruckGameAssets} from "../StarStruckGameAssets";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";

export class ForegroundView extends BaseView{
    private _layer:PIXI.Container;
    private _panel:PIXI.Sprite;
    
    constructor() {
        super();
        this._layer = StageManager.getLayer(StarStruckGameConfig.instance.LAYERS.REEL_BACKGROUND.name);
    }

    protected initAnimations():void {
        const mainSprite:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures(StarStruckGameAssets.GAME_PANEL)[0]);
        mainSprite.anchor.set(0.5, 0.5);
        this._panel = mainSprite;
        this.addChild(this._panel);
        this._layer.addChild(this);
    }

    protected onResize(data:IResizeData):void {
        this._panel.x = Helper.getSymbolPositions(1,1)[0]+1;
        this._panel.y = Helper.getSymbolPositions(1,1)[1];
        //this._panel.y = (data.orientation == Orientation.LANDSCAPE)? 50 : 40; //(topOffset + Helper.getSymbolPositions(0,0)[1]-OwlWarriorsGameConfig.instance.SYMBOL_HEIGHT/2)/2;
    }
}